import { type ReactNode } from 'react';
import { Switch } from '@leagueplatform/web-common-components';

// Shared Switch wiring for Settings preference toggles (Communication
// Preferences, Notifications). Uses the League Switch with `layout="row"` so the
// whole row is the clickable `<label>`, hides the on/off icon, and applies the
// Figma off-state track color. The label content is passed in (rendered by the
// caller) so each screen keeps its own typography tokens. `alignTop` top-aligns
// the switch to the title for multi-line (captioned) labels.
export const PreferenceToggle = ({
  id,
  label,
  checked,
  onToggle,
  alignTop = false,
  disabled = false,
}: {
  id: string;
  label: ReactNode;
  checked: boolean;
  onToggle: () => void;
  alignTop?: boolean;
  disabled?: boolean;
}) => (
  <Switch
    id={id}
    label={label}
    checked={checked}
    onChange={onToggle}
    disabled={disabled}
    layout="row"
    hideIcon
    css={{
      // Drop the Switch label's inline padding so the row's text lines up with
      // the section heading on the left and the toggle sits flush right.
      '.cc-switch-label': { paddingInline: '$none' },
      // Off-state track is the light "action disabled" grey per Figma (the
      // Genesis default $interactiveActionSubdued is too dark); on-state keeps
      // $interactiveActionPrimary from the component.
      '.cc-switch-root[data-state="unchecked"]': {
        backgroundColor: '$interactiveActionDisabled',
      },
      // Captioned rows align the switch to the title line.
      ...(alignTop
        ? { '.cc-switch-root-wrapper': { alignSelf: 'start' } }
        : {}),
    }}
  />
);
